(function () {
    'use strict';

    angular
        .module('core.services')
        .service('CompanyParameterService', CompanyParameterService)

    /** @ngInject */
    function CompanyParameterService(HttpService) {
        const CompanyParameterService = {
            post,
            deleteData
        }

        return CompanyParameterService;

        function post(companyParameterData) {
            return HttpService.post('/companies/parameters', companyParameterData);
        }

        function deleteData(companyParameterId) {
            return HttpService.delete(`/companies/parameters/${companyParameterId}`);
        }
    }
}());